import config from 'config';
import { useSelector } from 'react-redux';

import { selectUser } from '../reducers/user.selectors';
import { useAmplitudeExperiment } from './ampli';
import { isSearchPage } from './searchUtils';
import useRouter from './useRouter';

const useOpenInNewTabExperiment = (): boolean => {
	const user = useSelector(selectUser);
	const { match } = useRouter();
	const onSearchPage = isSearchPage(match.location.pathname);

	const { isReady, variant } = useAmplitudeExperiment(
		user,
		onSearchPage ? config.amplitudeExperiments.openInNewTab : undefined
	);

	return onSearchPage && isReady && variant === 'treatment';
};

export default useOpenInNewTabExperiment;
